import { render, staticRenderFns } from "./CategoryReport.vue?vue&type=template&id=560a410a"
import script from "./CategoryReport.vue?vue&type=script&lang=js"
export * from "./CategoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports